export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const API_KEY = '22b39f2f-243c-4588-8cbb-82ae0f7c1282';
export const DEFAULT_TIMEOUT = 10; // SECONDS
export const RESULTS_PER_PAGE = 10; // RECIPES
export const UPLOAD_OVERLAY_TIMEOUT = 1; // SECONDS
